import BSHtmlBaseBTStrategy from './BSHtmlBaseBTStrategy'

export default function BSHtmlBillableBTTimeStrategy() {}

BSHtmlBillableBTTimeStrategy.prototype = new BSHtmlBaseBTStrategy()

BSHtmlBillableBTTimeStrategy.prototype.addFirstHeaderRowCells = function(row, levelsNumber) {
    this.addCreatedCell(row, this.createBillableCell(levelsNumber, "timeType"))
}

BSHtmlBillableBTTimeStrategy.prototype.addColumnValueCells = function(row) {
    this.addTimeColumnValueCells(row)
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlBillableBTTimeStrategy.js